import {
  GetGeoAreaRequest,
  ParticipantsGeoareaApi
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useCallback, useMemo } from 'react';
import { handleError } from 'utils';
import { useGetDDServiceApiConfiguration } from './dd.service';

export const useParticipantsGeoAreaApi = () => {
  const configuration = useGetDDServiceApiConfiguration();
  const apiInstance = useMemo(
    () => new ParticipantsGeoareaApi(configuration),
    [configuration]
  );

  const getGeoArea = useCallback(
    (requestParameters: GetGeoAreaRequest) =>
      apiInstance.getGeoArea(requestParameters).catch(handleError),
    [apiInstance]
  );
  return {
    getGeoArea
  };
};
